import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { Builder } from '@src/routes/content/components/builder'
import { DaysBuilder } from '@src/routes/content/components/training-plan-builder/days-builder'
import { WorkoutSelector } from '@src/routes/content/components/training-plan-builder/workout-selector'
import { track } from '@src/util/functions'
import { Icon } from '@src/elements/icon/icon'
import { NotificationTypes } from '@src/util/constants'
import { ConfirmModal } from '@src/elements/modal/confirm-modal'
import { TrainingPlanName } from '@src/routes/content/components/training-plan-builder/training-plan-name'
import { AssignPlanToMember } from '@src/routes/content/components/training-plan-builder/assign-plan-member'
import { SaveTrainingPlan } from '@src/routes/content/components/training-plan-builder/save-plan'
import { TrainingPlanComposition } from '@src/routes/content/components/training-plan-builder/training-plan-composition'
import { TrainingPlanService } from '@src/service/training-plan'
import SessionManager from '@src/lib/session_manager'
import { LoadingScreen } from '@src/components/loading-screen/loading-screen/loading-screen'
import Member from '@src/data/member'

import './training-plan-builder.sass'
import { defaultWorkoutSelectorFilters } from '@src/state/dafaults'

@Component({
  computed: {
    planUpdated () {
      return this.$store.state.new_training_plan.updated
    },
    planName () {
      let plan = this.$store.state.new_training_plan.selectedTrainingPlan
      return plan ? plan.name : ''
    },
    member () {
      return this.$store.state.trainingMember || this.$store.state.memberProfile
    },
    startDate () {
      return this.$store.state.activePlanStartDate
    },
    trainingPlan () {
      return this.$store.state.new_training_plan
    }
  }
})
export class TrainingPlanBuilder extends Vue {

  protected showConfirmPopup: boolean = false
  protected needToConfirmExit: boolean = true
  protected loading = true

  private trainingPlan: any
  private member: Member
  private service: TrainingPlanService = new TrainingPlanService()

  constructor () {
    super()
    track('/training-plan-builder')
  }

  created () {
    window.addEventListener('beforeunload', this.onBeforeUnload)
    return this.loadPlan()
  }

  updated () {
    this.setDocumentTitle()
  }

  beforeDestroy () {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  }

  onBeforeUnload (e) {
    e.stopPropagation()
    e.preventDefault()

    e.returnValue = ''
  }

  setDocumentTitle () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MY_CONTENT')} - ${this.$root.$t('PAGE.CONTENT.TRAINING_PLAN.TAB_NAME')}`
  }

  loadPlan () {
    if (!SessionManager.Instance.isManager()) {
      if (!this.member) this.$store.dispatch('setMemberForActiveTraining', this.$store.state.user)
    }
    if (this.$route.params.id) {
      let planId = parseInt(this.$route.params.id, 10)
      this.service.getTrainingPlanWithDays(planId)
        .then(trainingPlan => this.onPlanRetrieved(trainingPlan))
        .catch(error => {
          console.error('failed to retrieve training plan', error)
          return this.loadNewTrainingPlan()
        })
    } else return this.loadNewTrainingPlan()
  }

  async onPlanRetrieved (trainingPlan) {
    await this.$store.dispatch('setSelectedTrainingPlan', { trainingPlan })
    this.loading = false
  }

  async loadNewTrainingPlan () {
    this.$store.dispatch('setActivePlanStartDate', '')
    if (!this.trainingPlan) await this.$store.dispatch('removeNewTrainingPlan')
    this.loading = false
  }

  render (h: CreateElement) {
    return this.loading ? <LoadingScreen/> : <Builder cssClass='training-plan-builder'>
      <TrainingPlanName slot={'topLeft'} />

      <AssignPlanToMember slot={'topMiddle'} />

      <SaveTrainingPlan slot={'topRight'} />

      <div onClick={this.closeBuilderAttempt} slot='close'><Icon name='util/close-circled' /></div>

      <WorkoutSelector slot={'selector'} />

      <DaysBuilder slot={'builder'} />

      <TrainingPlanComposition slot={'composition'} />

      <ConfirmModal show={this.showConfirmPopup}
                    closeCallback={this.closeBuilder}
                    message={this.$t('PAGE.CONTENT.CLOSE_CONFIRMATION')}
                    type={NotificationTypes.CONFIRM} />
    </Builder>
  }

  closeBuilderAttempt () {
    this.$store.dispatch('setTrainingPlanDays', [])
    if (this.needToConfirmExit) {
      this.showConfirmPopup = true
    } else {
      this.closeBuilder(true)
    }
  }

  closeBuilder (confirm?: boolean) {
    this.showConfirmPopup = false
    if (confirm === true) {
      this.$store.dispatch('filterWorkoutSelector', defaultWorkoutSelectorFilters)
      this.$router.go(-1)
    }
  }
}
